import React from "react";
import { motion as m, useScroll, useTransform } from "framer-motion";
import { Aurora, Container, Eyebrow, SplitText, Reveal } from "./ui";

/** Shared editorial masthead for interior pages. */
const PageHeader = ({ eyebrow, title, lead, meta, children }) => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 90]);
  const opacity = useTransform(scrollY, [0, 400], [1, 0.25]);

  return (
    <header className="relative overflow-hidden border-b border-[var(--color-border)] bg-paper-warm pb-16 pt-36 dark:bg-night-surface md:pb-24 md:pt-48">
      <Aurora tone="soft" />
      <m.div
        style={{ y, opacity }}
        className="pointer-events-none absolute -right-20 -top-24 hidden select-none font-display text-[18rem] leading-none text-azure/[0.04] dark:text-electric/[0.05] lg:block"
        aria-hidden="true"
      >
        {eyebrow}
      </m.div>

      <Container className="relative">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
        <SplitText
          as="h1"
          text={title}
          className="t-display mt-7 max-w-5xl"
          stagger={0.04}
        />
        {lead && (
          <Reveal delay={0.2}>
            <p className="t-lead mt-8 max-w-prose">{lead}</p>
          </Reveal>
        )}
        {meta && (
          <Reveal delay={0.28}>
            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-muted dark:text-slightwhite/60">
              {meta.map((item) => (
                <span key={item} className="flex items-center gap-2">
                  <span className="inline-block h-1 w-1 rounded-full bg-electric" />
                  {item}
                </span>
              ))}
            </div>
          </Reveal>
        )}
        {children}
      </Container>
    </header>
  );
};

export default PageHeader;
